
import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = icon;

  if (!IconComponent && name && FiIcons[name]) {
    IconComponent = FiIcons[name];
  }

  if (!IconComponent) {
    return <FiAlertTriangle {...props} />;
  }

  return <IconComponent {...props} />;
};

export default SafeIcon;
